import React from "react"
import CompilationForm from "../components/app-components/compilation-form"
import CompilationSteps from "../components/app-components/compilation-steps"
import useStore from "../utils/store";

export default function Compilation() {
  const compiling = useStore((state) => state.compiling);

  return <>{compiling ? <CompilationSteps /> : <CompilationForm />}</>
}
